import Swiper from "swiper";
import bb from "blingblingjs";

new Swiper(".js-el__testimonials", {
	loop : true,
	pagination: {
	    el: '.js-el__testimonials-pagination',
	    type: 'bullets',
	    clickable : true
	 },
});